import { ApolloError, useQuery } from "@apollo/client";

import { AppDashboardGetComponentsDocument, AppDashboardGetComponentsQuery } from "../queries.generated";

export type AppDashboardComponent = AppDashboardGetComponentsQuery["appDashboardGetComponents"][number];

export default function useAppDashboardGetComponents(): {
    data: AppDashboardComponent[];
    loading: boolean;
    error?: ApolloError;
} {
    const { data, loading, error } = useQuery(AppDashboardGetComponentsDocument, {
        fetchPolicy: "no-cache",
    });

    return {
        data: data?.appDashboardGetComponents ?? [],
        loading,
        error,
    };
}
